import { isEmptyObject } from '@sky-it-livedata-libraries/livedata-commons';
import { DataCardGpResultsQuery } from '../types';

/**
 * typeguard for DataCardGpResultsQuery
 * @param DataCardGpResultsQuery object passed to transformer
 */
export const isValidDataCardGpResults = (obj: DataCardGpResultsQuery): boolean => Boolean(obj?.data?.getCardGpResultsWidget && !isEmptyObject(obj.data.getCardGpResultsWidget));
